import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";

import mergeHandlers from "../../util/mergeHandlers";

import composeRefs from "../../util/composeRefs";

import InputContainer, { InputContainerProps } from "../InputContainer";

const phBase = css`
  color: ${select.color(["grey", 3])};
`;

export const inputPlaceholderStyle = css`
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    ${phBase}
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    ${phBase}
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    ${phBase}
  }
  :-moz-placeholder {
    /* Firefox 18- */
    ${phBase}
  }
`;

export const inputResetStyle = css`
  appearance: none;
  box-sizing: border-box;
  box-shadow: none;
  font-family: inherit;
  font-size: ${select.fontSize(-1)};
  color: inherit;
  background: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  ${inputPlaceholderStyle}
`;

const PlainInput = styled.input`
  ${inputResetStyle}
  height: 100%;
  width: 100%;
`;

type Props = {
  containerRef?: any;
  value?: string;
  type?: string;
} & React.HTMLAttributes<HTMLInputElement> &
  InputContainerProps;

function TextInput(
  {
    containerRef,
    style,
    className,
    disabled,
    error,
    label,
    type,
    focus,
    stretch,
    onClick,
    ...rest
  }: Props,
  ref: any
) {
  const [hasFocus, setFocus] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <InputContainer
      className={className}
      style={style}
      ref={containerRef}
      focus={hasFocus}
      disabled={disabled}
      error={error}
      stretch={stretch}
      label={label}
      onClick={(evt: any) => {
        if (evt.target !== inputRef.current) {
          inputRef.current!.focus();
        }
      }}
    >
      <PlainInput
        {...rest}
        type={type}
        disabled={disabled}
        ref={composeRefs(ref, inputRef)}
        onFocus={mergeHandlers(rest.onFocus, () => {
          setFocus(true);
        })}
        onBlur={mergeHandlers(rest.onBlur, () => {
          setFocus(false);
        })}
      />
    </InputContainer>
  );
}

export default React.forwardRef(TextInput);
